// default imports for react project
import React from "react";

// import default style components from react-bootstrap package
import { Row } from "react-bootstrap";

// import util to get current window dimensions
import useWindowDimensions from "utils/useWindowDimension";
import Button from "components/Buttons/Button";
import { useHistory } from "react-router";

// React functional component starts here..
function CardHeader({ image, title, disableButton }) {
  const { width } = useWindowDimensions();
  const history = useHistory();
  // return jsx to display on screen
  return (
    <div>
      <Row className="card__header__container d-flex justify-content-between flex-row">
        {width > 770 ? (
          <div
            className={`d-flex flex-row align-items-center ${
              width < 770 && "justify-content-between"
            }`}
            style={{ width: width > 770 ? "70%" : "100%" }}
          >
            <img
              src={image}
              alt=""
              className="card_header_img mr-1"
              style={{ marginRight: 40 }}
            />
            <span className="w-auto card__header text-center vertical-align">
              {title}
            </span>
          </div>
        ) : (
          <div
            className={`d-flex flex-row align-items-center position-relative justify-content-center`}
            style={{ width: "100%" }}
          >
            <img
              src={image}
              alt=""
              className="card_header_img mr-1"
              style={{ marginRight: 40, position: "absolute", left: "0px" }}
            />
            <span className="w-auto card__header text-center  vertical-align">
              {title}
            </span>
          </div>
        )}
        {!disableButton && (
          <Button
            color="white"
            bg="#da291c"
            name="Get Cover Now"
            size={16}
            containerStyle={{ marginRight: 30, fontWeight: 800 }}
            marginL={width > 770 ? 30 : 0}
            marginT={width > 770 ? 0 : 20}
            weight={900}
            onClick={() => history.push("/forms")}
            width={width > 770 ? "auto" : "120px"}
            align={width > 770 ? "left" : "center"}
            id="landing-page-cover-button"
          />
        )}
      </Row>
    </div>
  );
}

export default CardHeader;
